module.exports = __webpack_public_path__ + "img/Contract-Icon.6f11e6d7.svg";